import { Button, Container, FormSelect } from 'react-bootstrap'
import { useSpeech } from '../contexts/SpeechContext'
import { useEffect, useRef, useState } from 'react'
import { useLocalStorage } from '../contexts/LocalStorageContext'

const Welcome = () => {
  const { config, initConfig, setParam } = useLocalStorage()
  const { speak, stopSpeak } = useSpeech()

  const videoRef = useRef()

  const [camera, setCamera] = useState(-1)
  const [cameras, setCameras] = useState([])
  const [localStream, setLocalStream] = useState(null)
  const [step, setStep] = useState(0)

  const enableVoice = () => {
    setParam('enableVoice', true)
    setStep(2)
  }

  const disableVoice = () => {
    setParam('enableVoice', false)
    setStep(2)
  }

  const selectCamera = () => {
    setParam('camera', camera)
    setParam('welcome', true)

  }

  const stopCamera = () => {
    try {
      if (localStream) {
        localStream.getTracks().forEach((track) => track.stop())
        setLocalStream(null)
      }
    } catch {}
  }

  const startCamera = (id) => {
    stopCamera()

    const constraints = {
      audio: false,
      video: {
        width: {
          ideal: 3840,
        },
        height: {
          ideal: 2160,
        },
        deviceId: id,
      },
    }

    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
      if (videoRef.current) {
        setLocalStream(stream)
        videoRef.current.srcObject = stream
      }
    }).catch((error) => {
      console.error(error)
    })
  }

  useEffect(() => {
    const init = async () => {
      const constraints = { video: true, audio: false }
      const stream = await navigator.mediaDevices.getUserMedia(constraints)

      const requestCameraPermission = async () => {
        const tracks = stream.getTracks()
        tracks.forEach((track) => track.stop())
      }

      const loadCameraDevices = async () => {
        setCameras([])

        const devices = await navigator.mediaDevices.enumerateDevices()
        devices.forEach((device) => {
          if (device.kind === 'videoinput') {
            setCameras((previous) => [...previous, device])
          }
        })

        await requestCameraPermission()
      }

      await requestCameraPermission()
      await loadCameraDevices()
    }

    initConfig()

    setStep(0)

    init()

    speak(`
      Bienvenue dans votre programme de lecture de documents.
      Nous allons configurer l'application. Cliquez sur le bouton vert pour continuer.
    `)

    console.log(config)
  }, [])

  useEffect(() => {
    switch (step) {
      case 1:
        speak(`
          Souhaitez-vous activer l'aide vocale?
          Cliquez sur le bouton vert pour accepter ou le bouton rouge pour refuser.
        `)
        break

      case 2:
        if (config.enableVoice) {
          speak(`
            Appuyez sur la barre suppérieur et choisissez une caméra qui peut lire votre document.
            Cliquez sur le bouton vert pour valider votre choix.
          `)
        } else {
          stopSpeak()
        }
        break
      default:
    }
  }, [step, config.enableVoice])

  useEffect(() => {
    if (camera === -1) {
      stopCamera()
    } else {
      startCamera(camera)
    }
  }, [camera])

  return (
    <>
      <Container className="text-center w-100 h-100">
        <div className="d-flex flex-column">
          <h3 className="my-3">Bienvenue dans votre programme de lecture de documents</h3>
          { step === 0 && (
            <>
              <h4 className="mb-3">
                Nous allons configurer l'application
              </h4>
              <Button className="btn-success" onClick={() => setStep(1)}>
                <h3>
                  <i className="bi bi-arrow-right-circle-fill"> </i>
                  Continuer
                </h3>
              </Button>
            </>
          )}
          { step === 1 && (
            <>
              <h4 className="mb-3">
                <i className="bi bi-volume-up-fill"> </i>
                Souhaitez-vous activer l'aide vocale?
              </h4>

              <Button className="btn-success mb-3" onClick={enableVoice}>
                <h3>
                  <i className="bi bi-check-circle-fill"> </i>
                  Oui
                </h3>
              </Button>

              <Button className="btn-danger mb-3" onClick={disableVoice}>
                <h3>
                  <i className="bi bi-x-circle-fill"> </i>
                  Non
                </h3>
              </Button>
            </>
          )}
          { step === 2 && (
            <>
              <h4 className="mb-3">
                <i className="bi bi-camera-fill"> </i>
                Sélection de la caméra pour la lecture de document
              </h4>

              <FormSelect className="mb-3" onChange={(event) => setCamera(event.target.value)} value={-1}>
                <option value={-1}></option>
                {cameras.map((camera) => (
                  <option key={`camera-${camera.deviceId}`} value={camera.deviceId}>{camera.label}</option>
                ))}
              </FormSelect>

              <video ref={videoRef} className="flex-grow-1" muted={true} autoPlay={true} playsInline={true}></video>

              <Button className={camera === -1 ? 'my-3 btn-secondary' : 'my-3 btn-success'} disabled={camera === -1} onClick={() => selectCamera()}>
                <i className="bi bi-arrow-right-circle-fill"> </i>
                Continuer
              </Button>
            </>
          )}
        </div>
      </Container>

    </>
  )
}

export default Welcome
